import React, { Component } from 'react'

class TimeEstimations extends Component {
    state = {
        days: this.props.time.days,
        hours: this.props.time.hours,
        minutes: this.props.time.minutes,
    }

    checkKey = (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
            this.handleSubmit(e)
        }
    }

    componentDidMount = () => {
        var days = document.getElementById("estimated-time-days");
        var hours = document.getElementById("estimated-time-hours");
        var minutes = document.getElementById("estimated-time-minutes");
        days.addEventListener("keydown", this.checkKey);
        hours.addEventListener("keydown", this.checkKey);
        minutes.addEventListener("keydown", this.checkKey);
    }

    componentWillUnmount = () => {
        var days = document.getElementById("estimated-time-days");
        var hours = document.getElementById("estimated-time-hours");
        var minutes = document.getElementById("estimated-time-minutes");
        days.removeEventListener("keydown", this.checkKey);
        hours.removeEventListener("keydown", this.checkKey);
        minutes.removeEventListener("keydown", this.checkKey);
        this.handleSubmit()
    }

    setFocus() {
        let input = document.getElementById("estimated-time");
        input.focus();
    }
    
    editTime(e, field) {
        e.preventDefault()
        this.setState({
            [field]: e.target.value
        });
    }

    renderErrors = (error) => {
        return (
            <ul className="flex-centered shake-on-error" id="form-errors">
                {error}
            </ul>
        );
    }

    handleSubmit = (e) => {
        if (e) {
            e.preventDefault()
        }
        let estimate = { days: +this.state.days, hours: +this.state.hours, minutes: +this.state.minutes }
        this.props.submitStepEstimationEdit(estimate)
    }

    render() {
        return <form onSubmit={this.handleSubmit} className="flex-centered" id="edit-step-estimation-form">
            <span>
                <input type="number" id="estimated-time-days" 
                       name="estimated-time" min="0" max="365" 
                       value={this.state.days} 
                       onChange={(e) => this.editTime(e, "days")}
                       />
                <label htmlFor="estimated-time-days">days</label>
            </span>
            <span>
                <input type="number" id="estimated-time-hours" name="estimated-time" min="0" max="23" value={this.state.hours} onChange={(e) => this.editTime(e, "hours")}/>
                <label htmlFor="estimated-time-hours">hours</label>
            </span>
            <span>
                <input type="number" id="estimated-time-minutes" name="estimated-time" min="0" max="59" value={this.state.minutes} onChange={(e) => this.editTime(e, "minutes")}/>
                <label htmlFor="estimated-time-minutes">minutes</label>
            </span>
        </form> 
    }
}

export default TimeEstimations